// TODO: @mbenin validate form

/*
 // post json api/v1/newsletters
 var example_data_to_post = {
 "email": "yourmail@nomail.com",
 "fastcompany": {"Daily": true},
 "codesign": {"Daily": false},
 "cocreate": {"Daily": false},
 "coexist": {"Daily": false},
 "leadership": {"Daily": false},
 "technology": {"Weekly": false},
 "mostcreativepeople": false,
 "offers": false,
 "events": false
 };
 */
import $ from 'jquery';
import _ from 'underscore';
import siteUtil from '../utils/site_util';

const emailRegex = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
export default () => {
    const $newsLetterform = $('.js-newsletter-form');
    $newsLetterform.on('submit', (e) => {
        e.preventDefault();

        const site = siteUtil[$newsLetterform.attr('data-site')];
        const url = $newsLetterform.attr('action');
        const method = $newsLetterform.attr('method');
        const $newsLetterButton = $('.newsletter-button');
        const $emailInput = $('.newsletter-text-input');
        const email = $emailInput.val();

        if (site && email && emailRegex.test(email)) {
            const siteToNewsletterLookup = {
                fastcompany: 'Fast Company Daily',
                coexist: 'Co.Exist Daily',
                cocreate: 'Co.Create Daily',
                codesign: 'Co.Design Daily'
            };


            const baseJSON = {
                'Subscriptions:': {
                    'Events and Exclusive Offers': true
                }
            };


            let newsletterSubscribedTo = siteToNewsletterLookup[site];

            let modifiedJSON = _.extend({}, baseJSON);

            modifiedJSON['Subscriptions:'][newsletterSubscribedTo] = true;

            let baseData = {
                email: email
            };

            const formData = _.extend({}, modifiedJSON, baseData);

            return $.ajax({
                url: url,
                method: method,
                dataType: 'json',
                data: formData
            }).then(() => {
                $emailInput.val('Email submitted.');
                $emailInput.attr('disabled', true);
                $newsLetterButton.attr('disabled', true);
            });
        }
    });
};
